import { render } from "./lecteurVideo.vue?vue&type=template&id=6484bb34&scoped=true"
import script from "./lecteurVideo.vue?vue&type=script&lang=js"
export * from "./lecteurVideo.vue?vue&type=script&lang=js"

import "./lecteurVideo.vue?vue&type=style&index=0&id=6484bb34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6484bb34"]])

export default __exports__